import { ContentfulClientApi, createClient } from 'contentful';

// change these to include your own settings
const DEFAULT_CONFIG = {
  credentials: {
    accessToken: "6a29084a71c271cdaaf688a1b093e05369c7c3e649a991777e823dcc406c4826",
    space: "xsmqsou14fra"
  },
}

export class ContentfulService {
  public cdaClient: ContentfulClientApi;
  private config: {
    space: string,
    accessToken: string
  };

  constructor() {
    try {
      this.config = JSON.parse(localStorage.catalogConfig);
    } catch (e) {
      this.config = DEFAULT_CONFIG.credentials;
    }

    this._createClient();
  }

  private _createClient() {
    this.cdaClient = createClient({
      accessToken: this.config.accessToken,
      space: this.config.space
    });
  }
}


// WEBPACK FOOTER //
// ./src/services/contentfulClient.ts